import React, { useState } from 'react';
import { useTranslation } from '../hooks/useTranslation';

const KsvCalculatorRow = ({ costPrice, darkMode = false, onCalculate }) => {
  const [ksvPercent, setKsvPercent] = useState('');
  const { t } = useTranslation();

  const handleCalculate = () => {
    const cost = Number(costPrice);
    const ksv = Number(ksvPercent);

    if (!Number.isFinite(cost) || cost < 0) return;
    if (!Number.isFinite(ksv) || ksv <= 0 || ksv >= 100) return;

    const calculatedSalesPrice = (cost / (ksv / 100)).toFixed(2);
    onCalculate(calculatedSalesPrice);
  };

  return (
    <div className="flex items-center whitespace-nowrap gap-1">
      <span className={`text-xs ${darkMode ? 'text-gray-300' : 'text-gray-600'}`}>
        {t('KSV')}:
      </span>
      <div className="relative group">
        <svg
          className={`w-3.5 h-3.5 cursor-help ${darkMode ? 'text-gray-400' : 'text-gray-400'}`}
          fill="currentColor"
          viewBox="0 0 20 20"
        >
          <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
        </svg>
        <div className="absolute left-1/2 -translate-x-1/2 bottom-full mb-2 hidden group-hover:block z-50 w-64">
          <div className={`${darkMode ? 'bg-gray-800 text-gray-200 border-gray-700' : 'bg-white text-gray-700 border-gray-200'} rounded-lg shadow-lg border p-3 text-xs leading-relaxed whitespace-normal`}>
            <p className="font-semibold mb-1">{t('KSV-procent')}</p>
            <p>{t('KSV visar hur stor andel av försäljningspriset som är råvarukostnad. Exempel: om kostnaden är 30 kr och KSV är 25 %, blir försäljningspriset 120 kr (30 / 0,25). Lägre KSV ger högre försäljningspris och högre KSV ger lägre försäljningspris. OBS: Detta är bara ett hjälpverktyg - du kan alltid skriva försäljningspris direkt i rutan.')}</p>
            <div className={`absolute left-1/2 -translate-x-1/2 top-full w-0 h-0 border-l-[6px] border-r-[6px] border-t-[6px] border-l-transparent border-r-transparent ${darkMode ? 'border-t-gray-800' : 'border-t-white'}`}></div>
          </div>
        </div>
      </div>
      <input
        type="number"
        min="0.01"
        max="99.99"
        step="0.1"
        value={ksvPercent}
        onChange={(e) => setKsvPercent(e.target.value)}
        className={`w-12 px-1 py-0.5 text-xs border rounded ${darkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300 text-gray-900'} focus:outline-none focus:ring-1 focus:ring-secondary-green`}
        placeholder="%"
      />
      <button
        type="button"
        onClick={handleCalculate}
        className="px-2 py-0.5 text-xs rounded border border-secondary-green text-secondary-green hover:bg-secondary-green hover:text-white transition-colors duration-200"
        title={t('Beräkna försäljningspris från KSV-procent')}
      >
        {t('Beräkna')}
      </button>
    </div>
  );
};

export default KsvCalculatorRow;
